var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTicketGold = function SvgIconTicketGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 22",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconTicketGold_svg__a)",
    d: "m9.456 8.562.739 1.327 1.08-1.081a.4.4 0 0 1 .682.247l.376 4.135c.041.455-.57.64-.787.238l-.725-1.337-1.1 1.101a.4.4 0 0 1-.682-.247l-.368-4.141c-.04-.452.565-.638.785-.242Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconTicketGold_svg__b)",
    d: "M10.909 1.53a2.25 2.25 0 0 1 3.182 0l1.171 1.172c.511.51.42 1.228.162 1.66a1.25 1.25 0 0 0 1.713 1.713c.433-.257 1.15-.348 1.661.162L19.97 7.41a2.25 2.25 0 0 1 0 3.182L10.09 20.47a2.25 2.25 0 0 1-3.182 0l-1.172-1.172c-.51-.51-.419-1.227-.161-1.66a1.25 1.25 0 0 0-1.713-1.713c-.434.257-1.15.348-1.661-.163L1.03 14.591a2.25 2.25 0 0 1 0-3.182L10.91 1.53Zm2.121 1.061a.75.75 0 0 0-1.06 0L2.09 12.47a.75.75 0 0 0 0 1.06L3.159 14.6a2.75 2.75 0 0 1 3.742 3.742l1.069 1.068a.75.75 0 0 0 1.06 0L18.91 9.53a.75.75 0 0 0 0-1.06L17.841 7.4a2.75 2.75 0 0 1-3.742-3.742L13.03 2.591Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconTicketGold_svg__a",
    x1: 0.281,
    x2: 22.895,
    y1: 0.871,
    y2: 3.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DD91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79C1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconTicketGold_svg__b",
    x1: 0.281,
    x2: 22.895,
    y1: 0.871,
    y2: 3.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DD91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79C1A"
  })))));
};
export default SvgIconTicketGold;